
import React, { Component } from 'react';
import FormContainer from '../form/FormContainer';
import * as Utils from '../../utils/utils';

import './../../../scss/App.scss';
import { trackingWrapper } from '../../utils/analytics';


class PuzzleSelectPanel extends Component {

	constructor(props){
		super(props);

		//

		this.dayToUnlock = null;

		//

		this.state = {
			"dataReady": false,
			"hasSubscribed": false
		}

		this.mondayData = {"day": "monday", "title": null, "completedStyle": "", "isLocked": true};
		this.tuesdayData = {"day": "tuesday", "title": null, "completedStyle": "", "isLocked": true};
		this.wednesdayData = {"day": "wednesday", "title": null, "completedStyle": "", "isLocked": true};
		this.thursdayData = {"day": "thursday", "title": null, "completedStyle": "", "isLocked": true};
		this.fridayData = {"day": "friday", "title": null, "completedStyle": "", "isLocked": true};

	}

	componentDidMount(){
		this.loadUnlockData();
		this.loadPlayListData();
	}

	loadUnlockData(){
		const d = new Date();
		let dayIndex = d.getDay();
		const dayArray = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

		// if saturday or sunday, set day to friday
		if(dayIndex === 0 || dayIndex === 6){
			dayIndex = 5;
		}

		// unlock todays puzzle, but not stored in cookie
		let dayDataCollection = [
			this.mondayData,
			this.tuesdayData,
			this.wednesdayData,
			this.thursdayData,
			this.fridayData
		];

		dayDataCollection[dayIndex - 1].isLocked = false;

		/*
		for(let i = 1; i <= dayIndex; i++ ){
			dayDataCollection[(i - 1)].isLocked = false;
		}
		*/


		// get cookie data
		let week = Utils.getWeekNumber(new Date());
		let cookieName = "ppzUnlockedPuzzles" + week[0] + week[1];
		let currentCookie = window.$.cookie(cookieName);
		let cookieContents = {};

		if(currentCookie !== undefined){
			cookieContents = JSON.parse(currentCookie);
		}

		if(cookieContents["monday"]){
			this.mondayData.isLocked = false;
		}

		if(cookieContents["tuesday"]){
			this.tuesdayData.isLocked = false;
		}

		if(cookieContents["wednesday"]){
			this.wednesdayData.isLocked = false;
		}

		if(cookieContents["thursday"]){
			this.thursdayData.isLocked = false;
		}

		if(cookieContents["friday"]){
			this.fridayData.isLocked = false;
		}

	}

	loadPlayListData(){
		let _this = this;

		const jsonName = window.ppz.config.puzzleData.jsonFileName;

		const monPuzzlePath = window.ppz.config.puzzleData.puzzlePaths["monday"];
		const tuePuzzlePath = window.ppz.config.puzzleData.puzzlePaths["tuesday"];
		const wedPuzzlePath = window.ppz.config.puzzleData.puzzlePaths["wednesday"];
		const thuPuzzlePath = window.ppz.config.puzzleData.puzzlePaths["thursday"];
		const friPuzzlePath = window.ppz.config.puzzleData.puzzlePaths["friday"];

		//
		/*
		let cookieData = {
			"ROCKIN' OUT": false,
			"THE RED CARPET": true
		};

		window.$.cookie("ppzPlaylist", JSON.stringify(cookieData));

		let ppzPlaylist = window.$.cookie("ppzPlaylist");

		console.log('ppzPlaylist', JSON.parse(ppzPlaylist));
		*/
		//

		window.$.when(
			window.$.getJSON( (monPuzzlePath + jsonName) , function(data) {
				_this.mondayData.title = data.title;
			}),
			window.$.getJSON( (tuePuzzlePath + jsonName) , function(data) {
				_this.tuesdayData.title = data.title;
			}),
			window.$.getJSON( (wedPuzzlePath + jsonName) , function(data) {
				_this.wednesdayData.title = data.title;
			}),
			window.$.getJSON( (thuPuzzlePath + jsonName) , function(data) {
				_this.thursdayData.title = data.title;
			}),
			window.$.getJSON( (friPuzzlePath + jsonName) , function(data) {
				_this.fridayData.title = data.title;
			}),
		).then(function() {
			_this.getCookieData();

			_this.setState({
				"dataReady": true
			});

			_this.animateIn();
		});
	}

	getCookieData(){
		const ppzCookieData = window.$.cookie("ppzPlaylist");

		if(ppzCookieData !== undefined){
			const completedList = JSON.parse(ppzCookieData);

			//console.log("completedList: ", completedList);

			if(completedList[this.mondayData.title]){
				this.mondayData.completedStyle = " completed";
			}

			if(completedList[this.tuesdayData.title]){
				this.tuesdayData.completedStyle = " completed";
			}

			if(completedList[this.wednesdayData.title]){
				this.wednesdayData.completedStyle = " completed";
			}

			if(completedList[this.thursdayData.title]){
				this.thursdayData.completedStyle = " completed";
			}

			if(completedList[this.fridayData.title]){
				this.fridayData.completedStyle = " completed";
			}
		}
	}

	animateIn(){
		window.TweenMax.set(this.refs.panel, {transform:"translateY(10vh)"});
		window.TweenMax.to(this.refs.panel, 1, {transform:"translateY(0vh)"});
	}

	handlePuzzleSelection(dayData){
		if(dayData.isLocked){
			
			this.dayToUnlock = dayData;
			window.ppz.puzzleToUnlock = dayData;
			
			//console.log("this.state.hasSubscribed", this.state.hasSubscribed);
			if(this.state.hasSubscribed){
				trackingWrapper('event', 'PPZgame-unlock-puzzle-select-watch-video', {'event_category':'people-puzzler-game'});
				window.ppz.gamePage.showVideoAd("unlockPuzzle");
				window.ppz.overlayManager.closeOverlay();
			}
			else {
				trackingWrapper('event', 'PPZgame-unlock-puzzle-select-newsletter', {'event_category':'people-puzzler-game'});
				window.ppz.overlayManager.setPanel("unlockPuzzle");
			}			
		}
		else {
			window.ppz.overlayManager.closeOverlay();
			window.ppz.app.initPuzzleDay(dayData.day);
		}
	}

	completeUnlockDay(){
		this.dayToUnlock.isLocked = false;
		this.dayToUnlock = null;
	}


	render(){

		const {dataReady} = this.state;

		let monActive = this.mondayData.isLocked ? "" : " active";
		let tueActive = this.tuesdayData.isLocked ? "" : " active";
		let wedActive = this.wednesdayData.isLocked ? "" : " active";
		let thuActive = this.thursdayData.isLocked ? "" : " active";
		let friActive = this.fridayData.isLocked ? "" : " active";

		return (
			<div>
				{dataReady ?
					<div id="puzzleSelectPanel" ref="panel">
						<div className="heading">SELECT A PUZZLE</div>
						<div className="body">
							<div className="line">
								<div className={"checkmark fas fa-check-circle" + this.mondayData.completedStyle}></div>
								<div className={"puzzleBtn" + monActive} onClick={() => this.handlePuzzleSelection(this.mondayData)}>
									<span className="locked fa-solid fa-lock"></span>
									<span className="unlocked fa-solid fa-lock-open"></span>
									{this.mondayData.title}</div>
								<div className="day">(Monday)</div>
							</div>
							<div className="line">
								<div className={"checkmark fas fa-check-circle" + this.tuesdayData.completedStyle}></div>
								<div className={"puzzleBtn" + tueActive} onClick={() => this.handlePuzzleSelection(this.tuesdayData)}>
									<span className="locked fa-solid fa-lock"></span>
									<span className="unlocked fa-solid fa-lock-open"></span>
									{this.tuesdayData.title}</div>
								<div className="day">(Tuesday)</div>
							</div>
							<div className="line">
								<div className={"checkmark fas fa-check-circle" + this.wednesdayData.completedStyle}></div>
								<div className={"puzzleBtn" + wedActive} onClick={() => this.handlePuzzleSelection(this.wednesdayData)}>
									<span className="locked fa-solid fa-lock"></span>
									<span className="unlocked fa-solid fa-lock-open"></span>
									{this.wednesdayData.title}</div>
								<div className="day">(Wednesday)</div>
							</div>
							<div className="line">
								<div className={"checkmark fas fa-check-circle" + this.thursdayData.completedStyle}></div>
								<div className={"puzzleBtn" + thuActive} onClick={() => this.handlePuzzleSelection(this.thursdayData)}>
									<span className="locked fa-solid fa-lock"></span>
									<span className="unlocked fa-solid fa-lock-open"></span>
									{this.thursdayData.title}</div>
								<div className="day">(Thursday)</div>
							</div>
							<div className="line">
								<div className={"checkmark fas fa-check-circle" + this.fridayData.completedStyle}></div>
								<div className={"puzzleBtn" + friActive} onClick={() => this.handlePuzzleSelection(this.fridayData)}>
									<span className="locked fa-solid fa-lock"></span>
									<span className="unlocked fa-solid fa-lock-open"></span>
									{this.fridayData.title}</div>
								<div className="day">(Friday)</div>
							</div>
						</div>
						<div className="closeBtn" onClick={() => window.ppz.overlayManager.closeOverlay()}>
							<div className="x"></div>
						</div>
						<div className="hidden">
							<FormContainer 
								//returns showNewsletter=false on mount if the user has submitted a newsletter within 45 days
								handleShowNewsletter={hasNotSubscribed=>{
									console.log('hasNotSubscribed', hasNotSubscribed);
									this.setState({hasSubscribed: !hasNotSubscribed});
								}}

								//callback when newsletter has been successfully submitted
								handleNewsletterSubmit={()=>{
									//console.log('handleNewsletterSubmit');
									//this.setState({hasSubmitted: true, hasSubscribed: true});
								}}

								//submit button label
								submitLabel="Unlock"
								/>
						</div>
						
					</div>
					
				:
					<div></div>
				}
			</div>
		);
	}
}

export default PuzzleSelectPanel;


// WEBPACK FOOTER //
// ./src/js/components/overlays/PuzzleSelectPanel.js